module.exports = __webpack_public_path__ + "static/media/vertex-5002x.4f710341.jpg";